import { HStack, Stack } from '@chakra-ui/react';

import { ActiveLink } from '$components/chakra/active-link';

interface NavbarProps {
  isLargeScreen: boolean;
  size?: 'default' | 'large';
  onNavigate?: () => void;
}

const links = [
  { href: '/projects', label: 'Projetos', exact: false },
  { href: '/posts', label: 'Blog', exact: false },
  { href: '/#about', label: 'Sobre', exact: true },
  { href: '/#contact', label: 'Contato', exact: true },
];

export function Navbar({
  isLargeScreen,
  size = 'default',
  onNavigate,
}: NavbarProps) {
  const Wrapper = isLargeScreen ? HStack : Stack;
  const isLarge = size === 'large';

  return (
    <Wrapper
      as="nav"
      spacing={isLargeScreen ? '24px' : isLarge ? '14px' : '18px'}
      align={isLargeScreen ? 'center' : 'start'}
    >
      {links.map((link) => (
        <ActiveLink
          key={link.href}
          href={link.href}
          shouldMatchExactHref={link.exact}
          onClick={onNavigate}
          fontFamily={isLarge ? 'display' : 'body'}
          fontSize={isLarge ? '34px' : '14px'}
          fontWeight={isLarge ? 600 : 500}
        >
          {link.label}
        </ActiveLink>
      ))}
    </Wrapper>
  );
}
